const getHomeURL = (lang) => (
  (!lang || lang === 'lv') ? '/' : `/${lang}/`
);

export default getHomeURL;



// WEBPACK FOOTER //
// ./src/utils/getHomeURL.js